import { Lang } from "../types/general";

export const hakalotTerms = Object.freeze({
    TEN_DAYS_REASON: {
        [Lang.he]: "בגין 10 ימי מילואים",
        [Lang.en]: "10 days in Miluim"
    },

    THREE_WEEKS_FIREST_REASON: {
        [Lang.he]: 'בגין 3 שבועות של ימי מילואים בשנת הלימודים תשפ"ד',
        [Lang.en]: "For 3 weeks of miluim days during the semester"
    },

    THREE_WEEKS_SHNAT_LIMNUDIM_REASON: {
        [Lang.he]: 'בגין 3 שבועות של ימי מילואים בשנת הלימודים תשפ"ד',
        [Lang.en]: "For 3 weeks of miluim days during the semester"
    },

    THREE_WEEKS_SECOND_REASON: {
        [Lang.he]: 'בגין 3 שבועות נוספים של ימי מילואים בשנת הלימודים תשפ"ד',
        [Lang.en]: "For 3 additional weeks of miluim days during the semester"
    },

    TWENTY_EIGHT_DAYS_REASON: {
        [Lang.he]: 'בגין שירות מילואים של 28 ימים ומעלה בשנת הלימודים',
        [Lang.en]: "28 days in Miluim"
    },

    FIFTY_DAYS_REASON: {
        [Lang.he]: "בגין 50 ימי מילואים",
        [Lang.en]: "50 days in Miluim"
    },

    FROM_30_UP_TO_60_DAYS_REASON: {
        [Lang.he]: "בגין שירות מילואים של 30-60 יום החל מ-7.10.23",
        [Lang.en]: ""
    },

    FROM_61_UP_TO_99_DAYS_REASON: {
        [Lang.he]: "בגין שירות מילואים של 61-99 יום החל מ-7.10.23",
        [Lang.en]: ""
    },

    FROM_100_AND_UP_REASON: {
        [Lang.he]: "בגין שירות מילואים של 100 ימים ומעלה החל מ-7.10.23",
        [Lang.en]: ""
    },

    FROM_200_AND_UP_REASON: {
        [Lang.he]: "בגין שירות מילואים של 200 ימים ומעלה החל מ-7.10.23",
        [Lang.en]: ""
    },

    // extend hakalot for 24-25:
    IN_ONE_SEMESTER_21_DAYS: {
        [Lang.he]: 'בגין שירות מילואים של 21 ימים ומעלה בסמסטר אחד בתשפ"ה',
        [Lang.en]: ""
    },

    IN_YEAR_35_DAYS: {
        [Lang.he]: 'בגין שירות מילואים של 35 ימים ומעלה בשנת הלימודים תשפ"ה',
        [Lang.en]: ""
    },

    IN_ONE_SEMESTER_35_DAYS: {
        [Lang.he]: 'בגין שירות מילואים של 35 ימים ומעלה בסמסטר אחד בתשפ"ה',
        [Lang.en]: ""
    },

    IN_ONE_SEMESTER_50_DAYS: {
        [Lang.he]: 'בגין שירות מילואים של 50 ימים ומעלה בסמסטר אחד בתשפ"ה',
        [Lang.en]: ""
    },

    IN_YEAR_100_DAYS: {
        [Lang.he]: 'בגין שירות מילואים של 100 ימים ומעלה בשנת הלימודים תשפ"ה',
        [Lang.en]: ""
    },

    BEFORE_60_DAYS: {
        [Lang.he]: 'בגין שירות מילואים של 60 ימים ומעלה ב3 החודשים שלפני שנת הלימודים תשפ"ה- תקף רק למי שלמד בתשפ"ד',
        [Lang.en]: ""
    },
})
